import {observable} from 'mobx';

export interface BrowserInfo {
    browserName: string;
    isSupportedBrowser: boolean;
    isOldVersion?: boolean;
    isExcludedVersion?: boolean;
    browsers: any;
}

export class BrowserNotSupportedState {
    @observable browserInfo: BrowserInfo | null = null;
    @observable userName: string = '';
}
